import React, { useEffect, useState } from "react";
import "./Notify.css";

// ── Global popup system: toasts + a confirm modal, usable from anywhere ──
let _id = 0;

// Show a popup toast: notify("Saved", "success" | "error" | "info")
export function notify(message, type = "success") {
  window.dispatchEvent(new CustomEvent("pf-toast", { detail: { id: ++_id, message: String(message || ""), type } }));
}

// Popup confirm — returns a Promise<boolean>. Replaces window.confirm.
//   const ok = await confirmDialog({ title, message, danger, okText });
export function confirmDialog(opts) {
  const detail = typeof opts === "string" ? { message: opts } : opts || {};
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent("pf-confirm", { detail: { ...detail, resolve } }));
  });
}

export function NotifyHost() {
  const [toasts, setToasts] = useState([]);
  const [confirm, setConfirm] = useState(null);

  useEffect(() => {
    const onToast = (e) => {
      const t = e.detail;
      setToasts((cur) => [...cur, t]);
      setTimeout(() => setToasts((cur) => cur.filter((x) => x.id !== t.id)), 3500);
    };
    const onConfirm = (e) => setConfirm(e.detail);
    window.addEventListener("pf-toast", onToast);
    window.addEventListener("pf-confirm", onConfirm);
    return () => {
      window.removeEventListener("pf-toast", onToast);
      window.removeEventListener("pf-confirm", onConfirm);
    };
  }, []);

  const close = (ok) => {
    if (confirm?.resolve) confirm.resolve(ok);
    setConfirm(null);
  };

  const icon = (type) =>
    type === "error" ? "bi-x-circle-fill" : type === "info" ? "bi-info-circle-fill" : "bi-check-circle-fill";

  return (
    <>
      <div className="pf-toast-host">
        {toasts.map((t) => (
          <div key={t.id} className={`pf-toast pf-toast--${t.type}`}>
            <i className={`bi ${icon(t.type)}`} />
            <span>{t.message}</span>
          </div>
        ))}
      </div>

      {confirm && (
        <div className="pf-confirm-overlay" onClick={() => close(false)}>
          <div className="pf-confirm" onClick={(e) => e.stopPropagation()}>
            {confirm.danger && <div className="pf-confirm-icon danger"><i className="bi bi-exclamation-triangle-fill" /></div>}
            {confirm.title && <h5>{confirm.title}</h5>}
            <p>{confirm.message}</p>
            <div className="pf-confirm-actions">
              <button className="pf-confirm-cancel" onClick={() => close(false)}>{confirm.cancelText || "Cancel"}</button>
              <button className={`pf-confirm-ok ${confirm.danger ? "danger" : ""}`} onClick={() => close(true)}>
                {confirm.okText || "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
